import Vue from 'vue'
import App from './App.vue'

import 'assets/styles/main.sass';
import 'assets/icons/style.css';

// element-ui按需引，crf需要
import { Row, Col } from 'element-ui';
// 引入样式文件
import 'element-ui/lib/theme-chalk/index.css';
// import 'assets/styles/_element.sass';

Vue.use(Row);
Vue.use(Col);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
